<template>
  <div class="vue-scope">
    <v-app id="inspire">
      <v-content>
        <SnackBar />
        <router-view />
      </v-content>
    </v-app>
  </div>
</template>

<script>

import SnackBar from "../components/SnackBar";
export default {
    name: 'MainLayout',
    components: {SnackBar},
    data () {
        return {
            drawer: null,
            items: [
                { title: 'Español' },
                { title: 'English' },
            ],
            socials: [
            ],
        };
    },
    created () {
        // if (this.$user) {
        //     this.$socket.emit('LOGIN', {id: this.$user._id});
        // }
    },
    methods: {
        goHome () {
            this.goTo('home');
        },
        goCreate () {
            this.goTo('create');
        },
        goTo (routeName) {
            if (this.$router.history.current.name !== routeName) {
                this.$router.push(routeName);
            }
        },
        changeLanguage(lang) {
          let language = 'ca';
          if (lang === 'Spanish' || lang === 'Castellà' || lang === 'Español') language = 'es';
          if (lang === 'English' || lang === 'Anglès' || lang === 'Inglés') language = 'en';

          const path = window.location.pathname.split('/');
          if (['es', 'en', 'ca'].includes(path[1])) {
            path[1] = language;
          } else {
            path.splice(1, 0, language);
          }

          const newUrl = window.location.origin + path.join('/') + window.location.search + window.location.hash;
          window.location.href = newUrl;
        }
    },

    // sockets: {
    //     STAMINA(data) {
    //         this.$root.$emit('update-stamina', {value: data*1});
    //     }
    // },
};
</script>
